/* PLEVO — Salt Print theme JS.
   One file for every template. EVERY block is an IIFE that returns early when
   its elements are absent, so a page missing one component cannot break the
   others. Rebuilt 2026-07-29 after a duplicated, unguarded header block took
   down the entire script on gated pages. */

// Header solidify. GUARDED. The unguarded version called onScroll()
// immediately at top level, and on a gated page there is no header — so it
// threw, aborted the whole file, and silently killed the burger, both
// carousels, the product gallery and the tier selector. One null reference
// took out every interaction on the page. Found via the browser console on
// the Shopify preview, not by reading the source.
(function(){
  var hdr=document.getElementById('hdr');
  if(!hdr)return;
  var onScroll=function(){hdr.classList.toggle('is-solid',window.scrollY>40)};
  onScroll();addEventListener('scroll',onScroll,{passive:true});
})();

// Dropdown. Guarded for the same reason: a gated page has no burger.
(function(){
  var b=document.getElementById('burger'),n=document.getElementById('nav');
  if(!b||!n)return;
  function setOpen(v){n.dataset.open=v;b.setAttribute('aria-expanded',v);if(!v)b.focus();}
  b.addEventListener('click',function(e){e.stopPropagation();setOpen(n.dataset.open!=='true')});
  document.addEventListener('click',function(e){
    if(n.dataset.open==='true'&&!n.contains(e.target))setOpen(false);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&n.dataset.open==='true')setOpen(false)});
  n.addEventListener('click',function(e){if(e.target.tagName==='A')setOpen(false)});
})();

// Continuity reveal. Adds the .reveal class from JS so that with scripting
// dead every section renders visible — content never depends on a script.
// Unobserves after firing: this happens once, it is not a scroll effect.
(function(){
  if(!('IntersectionObserver' in window))return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var sel=['.shoot','.mech__in','.use__in','.fit__in','.founder__in',
           '.mail__in','.cta__in','.spec-sec__in','.wont__in','.ft__in'];
  // .pdp__in is deliberately absent: a transform on it would make it the
  // containing block for the sticky buy panel and break the stick.
  var els=[];
  sel.forEach(function(s){
    [].slice.call(document.querySelectorAll(s)).forEach(function(e){els.push(e)});
  });
  if(!els.length)return;
  var fired=false;
  var io=new IntersectionObserver(function(entries){
    fired=true;
    entries.forEach(function(en){
      if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}
    });
  },{rootMargin:'0px 0px -8% 0px',threshold:.06});
  els.forEach(function(e){e.classList.add('reveal');io.observe(e);});
  // Failsafe. The observer fires on observe() for anything already in view, so
  // this should never run. If it ever does, the reveal has failed and the page
  // would otherwise sit blank forever — strip the class and show the content.
  // Content availability beats the animation, always.
  setTimeout(function(){
    if(fired)return;
    els.forEach(function(e){e.classList.remove('reveal');});
  },3000);
})();

// Shoot carousel — infinite loop + drag.
//
// Loop: the slide set is tripled (A B C) and the view starts on B. When the
// user comes to rest on the far edge of A or C, scrollLeft jumps by exactly
// one set width. The sets are identical, so the jump is invisible.
//
// The jump happens ONLY once scrolling has stopped. Repositioning mid-scroll
// cancels the browser's momentum/smooth animation and reads as a stutter.
//
// Drag is bound for mouse pointers only. Touch already scrolls natively and
// with better momentum than anything reimplemented here; hijacking it would
// make mobile worse, not better.
(function(){
  var t=document.getElementById('shoot-track');
  if(!t)return;
  var originals=[].slice.call(t.children);
  var n=originals.length;
  if(!n)return;

  function addSet(where){
    var frag=document.createDocumentFragment();
    originals.forEach(function(li){
      var c=li.cloneNode(true);
      c.setAttribute('aria-hidden','true');  // clones are decorative duplicates
      var img=c.querySelector('img');
      if(img){img.alt='';img.setAttribute('draggable','false');}
      frag.appendChild(c);
    });
    if(where==='before')t.insertBefore(frag,t.firstChild); else t.appendChild(frag);
  }
  addSet('before'); addSet('after');
  originals.forEach(function(li){
    var img=li.querySelector('img'); if(img)img.setAttribute('draggable','false');
  });

  var setW=0;
  function measure(){
    var kids=t.children;
    // distance from set A's first slide to set B's first slide = one full set
    // including the trailing gap. Read from layout, never computed by hand.
    setW=kids[n].offsetLeft-kids[0].offsetLeft;
  }
  function home(){ measure(); jump(setW); }
  function jump(x){
    var prev=t.style.scrollBehavior;
    t.style.scrollBehavior='auto';   // never animate the reposition
    t.scrollLeft=x;
    t.offsetHeight;                  // flush before restoring
    t.style.scrollBehavior=prev;
  }
  function wrap(){
    if(!setW)return;
    if(t.scrollLeft>=setW*2-2)      jump(t.scrollLeft-setW);
    else if(t.scrollLeft<=2)        jump(t.scrollLeft+setW);
  }
  home();

  // wrap on rest: native scrollend where available, idle timer everywhere else
  if('onscrollend' in window){
    t.addEventListener('scrollend',wrap);
  }else{
    var idle;
    t.addEventListener('scroll',function(){
      clearTimeout(idle); idle=setTimeout(wrap,140);
    },{passive:true});
  }
  addEventListener('resize',home,{passive:true});

  function step(){
    var li=t.children[0];
    var gap=parseFloat(getComputedStyle(t).columnGap)||0;
    return li.getBoundingClientRect().width+gap;
  }
  [].slice.call(document.querySelectorAll('.shoot__btn')).forEach(function(b){
    // no disabled state any more — with a loop there is always a next slide
    b.disabled=false;
    b.addEventListener('click',function(){
      t.scrollBy({left:step()*(+b.dataset.dir),behavior:'smooth'});
    });
  });

  // mouse drag only; touch keeps native scrolling
  var down=false,startX=0,startL=0,moved=0;
  t.addEventListener('pointerdown',function(e){
    if(e.pointerType!=='mouse')return;
    down=true;moved=0;startX=e.clientX;startL=t.scrollLeft;
    try{t.setPointerCapture(e.pointerId);}catch(_){}  // never let capture kill the drag
    t.classList.add('is-dragging');
  });
  t.addEventListener('pointermove',function(e){
    if(!down)return;
    var dx=e.clientX-startX;
    moved=Math.abs(dx);
    t.scrollLeft=startL-dx;
    if(moved>3)e.preventDefault();
  });
  function endDrag(e){
    if(!down)return;
    down=false;
    t.classList.remove('is-dragging');
    try{t.releasePointerCapture(e.pointerId);}catch(_){}
    wrap();
  }
  t.addEventListener('pointerup',endDrag);
  t.addEventListener('pointercancel',endDrag);
})();

// PDP gallery. Thumbnails page the track; the track pages the thumbnails.
// One source of truth: scroll position. Nothing stores a "current index".
(function(){
  var t=document.getElementById('gal-track'),th=document.getElementById('gal-thumbs');
  if(!t||!th)return;
  var btns=[].slice.call(th.querySelectorAll('button'));
  function page(){return t.clientWidth;}
  function index(){return Math.round(t.scrollLeft/page());}
  function mark(){
    var i=index();
    btns.forEach(function(b,n){b.setAttribute('aria-selected',n===i?'true':'false');});
  }
  btns.forEach(function(b){
    b.addEventListener('click',function(){
      t.scrollTo({left:(+b.dataset.i)*page(),behavior:'smooth'});
    });
  });
  [].slice.call(document.querySelectorAll('.gal__arrow')).forEach(function(a){
    a.addEventListener('click',function(){
      var n=index()+(+a.dataset.dir);
      n=Math.max(0,Math.min(btns.length-1,n));
      t.scrollTo({left:n*page(),behavior:'smooth'});
    });
  });
  function edges(){
    var i=index(),p=document.querySelector('.gal__arrow--prev'),n=document.querySelector('.gal__arrow--next');
    if(p)p.disabled=i<=0;
    if(n)n.disabled=i>=btns.length-1;
  }
  t.addEventListener('scroll',function(){mark();edges();},{passive:true});
  addEventListener('resize',function(){mark();edges();},{passive:true});
  mark();edges();

  // mouse drag only; touch keeps native momentum scrolling
  var down=false,sx=0,sl=0;
  t.addEventListener('pointerdown',function(e){
    if(e.pointerType!=='mouse')return;
    down=true;sx=e.clientX;sl=t.scrollLeft;
    try{t.setPointerCapture(e.pointerId);}catch(_){}
    t.classList.add('is-dragging');
  });
  t.addEventListener('pointermove',function(e){
    if(!down)return;
    var dx=e.clientX-sx;t.scrollLeft=sl-dx;
    if(Math.abs(dx)>3)e.preventDefault();
  });
  function up(e){
    if(!down)return;down=false;t.classList.remove('is-dragging');
    try{t.releasePointerCapture(e.pointerId);}catch(_){}
    // settle to the nearest frame; a half-shown photo is not a state
    t.scrollTo({left:index()*page(),behavior:'smooth'});
  }
  t.addEventListener('pointerup',up);
  t.addEventListener('pointercancel',up);
})();

// Tier selection, variant version (2026-07-30). The radios ARE the variant
// selector \u2014 name="id" is what Shopify's product form posts \u2014 so this no longer
// writes a quantity; quantity is always 1 and the pack size lives in the variant.
// Both buttons still show the selected tier's price, because a stale label on a
// real add-to-cart button is a lie about what the card is about to be charged.
// The price and pack label are read off the radio rather than recomputed, so the
// only source of either number is Liquid.
(function(){
  var cta=document.getElementById('pdp-cta');
  if(!cta)return;
  var radios=[].slice.call(document.querySelectorAll('.tiers input[name="id"]'));
  if(!radios.length)return;
  var barCta=document.getElementById('atc-cta'),barTier=document.getElementById('atc-tier');
  var sum=document.getElementById('tier-sum-text');
  function sync(){
    var r=radios.filter(function(x){return x.checked})[0];
    if(!r)return;
    var label=(cta.dataset.prefix||'Add to cart \u2014')+' '+r.dataset.price;
    cta.textContent=label;
    if(barCta)barCta.textContent=label;
    if(barTier&&r.dataset.label)barTier.textContent=r.dataset.label;
    // Savings summary. data-save is empty on the One Bottle card by design
    // \u2014 \u00a73 gives that tier "Free shipping" and no savings claim \u2014 so the
    // fallback is a shipping line, never "Save $0" and never a disappearing
    // row, which would reflow the button under the cursor mid-click.
    if(sum){
      var s=r.dataset.save;
      sum.textContent=s
        ?((sum.dataset.before||'')+' '+s+' '+(sum.dataset.after||'')).trim()
        :(sum.dataset.nosave||'');
    }
  }
  radios.forEach(function(r){r.addEventListener('change',sync)});
  sync();

  // sticky bar appears only once the real button has scrolled away
  var bar=document.getElementById('atc');
  if(bar&&'IntersectionObserver' in window){
    new IntersectionObserver(function(en){
      var off=!en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.dataset.show=off?'true':'false';
      bar.setAttribute('aria-hidden',off?'false':'true');
      if(barCta)barCta.setAttribute('tabindex',off?'0':'-1');
    },{threshold:0}).observe(cta);
  }
})();


// CART DRAWER. Every mutation goes to Shopify and the drawer is re-rendered
// from Liquid via the Section Rendering API — line items, discounts and totals
// are never computed in JavaScript, so what the drawer shows and what checkout
// charges cannot drift apart.
(function(){
  var d=document.getElementById('cart-drawer');
  if(!d)return;

  var lastFocus=null;
  function open(){
    lastFocus=document.activeElement;
    d.dataset.open='true'; d.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    var x=d.querySelector('.drawer__x'); if(x)x.focus();
  }
  function close(){
    d.dataset.open='false'; d.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    if(lastFocus)lastFocus.focus();
  }

  // the header cart keeps its href, so with JS dead it still reaches /cart
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-cart-open]');
    if(t){e.preventDefault();open();return;}
    if(e.target.closest('[data-close]')){e.preventDefault();close();}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&d.dataset.open==='true')close();
  });

  // Fetching and swapping are separate so a caller can inspect the fresh markup
  // BEFORE committing it. The discount field needs that: on a refused code it
  // has to keep the panel the user is typing in, message and all.
  function drawerHtml(){
    return fetch('/?sections=cart-drawer',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()})
      .then(function(j){
        var html=j['cart-drawer'];
        if(!html)return null;
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        return tmp;
      });
  }

  function swapPanel(tmp){
    if(!tmp)return;
    // swap only the panel so the open state and scrim are untouched
    var fresh=tmp.querySelector('.drawer__panel');
    var cur=d.querySelector('.drawer__panel');
    if(fresh&&cur)cur.replaceWith(fresh);
    syncHeaderCount();
  }

  function refresh(){
    return drawerHtml().then(swapPanel);
  }

  function syncHeaderCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()})
      .then(function(c){
        var badge=document.querySelector('.hdr__count');
        var cartLink=document.querySelector('.hdr__cart');
        if(cartLink)cartLink.setAttribute('aria-label','Cart, '+c.item_count+' item'+(c.item_count===1?'':'s'));
        if(c.item_count>0){
          if(!badge&&cartLink){badge=document.createElement('span');badge.className='hdr__count';cartLink.appendChild(badge);}
          if(badge)badge.textContent=c.item_count;
        } else if(badge){ badge.remove(); }
      });
  }

  // REMOVE AN APPLIED CODE. POST /cart/update.js with an empty discount is what
  // does it — measured: a $23 cart at $20.70 with FIRST100 goes back to $23.00
  // and total_discount to 0.
  //
  // Three things that do NOT work, all tried against the live cart before this
  // landed, because each one looks plausible:
  //   /cart/clear.js          — empties the cart, discount survives the re-add
  //   /discount/ (bare)       — 404
  //   expiring discount_code  — the cookie is readable and deletable, and
  //                             deleting it changes nothing; the discount is
  //                             held on the cart server-side, not in that cookie
  d.addEventListener('click',function(e){
    if(!e.target.closest('[data-discount-clear]'))return;
    e.preventDefault();
    d.dataset.busy='true';
    fetch('/cart/update.js',{method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({discount:''})})
      .then(refresh)
      .finally(function(){d.dataset.busy='false';});
  });

  // quantity steppers and remove, delegated so they survive a re-render
  d.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty]');
    if(!b)return;
    e.preventDefault();
    var body=new URLSearchParams({id:b.dataset.key,quantity:b.dataset.qty});
    d.dataset.busy='true';
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:body})
      .then(refresh).finally(function(){d.dataset.busy='false';});
  });

  // DISCOUNT CODE. /discount/<code> is the only storefront route that applies a
  // code without going to checkout: it sets the discount cookie and redirects.
  // It answers 200 whether or not the code was accepted, so the response itself
  // tells us nothing.
  //
  // Nor does /cart.js: applying FIRST100 to a $23 cart drops total_price to
  // $20.70 and sets total_discount, but discount_applications comes back EMPTY
  // — measured live, and it is why the first version of this reported failure on
  // a code that had actually worked. Liquid's cart.discount_applications does
  // see it. So the check is the same rule the line items already follow: ask
  // Liquid, never recompute. Re-render the section and read whether the applied
  // state came back.
  //
  // Delegated, because a successful apply replaces the panel this form lives in.
  d.addEventListener('submit',function(e){
    var f=e.target.closest('[data-discount]');
    if(!f)return;
    e.preventDefault();
    var input=f.querySelector('.dcode__in');
    var msg=f.querySelector('[data-discount-msg]');
    var code=(input.value||'').trim();
    if(!code){input.focus();return;}
    var btn=f.querySelector('.dcode__go');
    btn.disabled=true; f.dataset.busy='true';
    if(msg){msg.textContent='Checking…'; msg.dataset.state='';}
    fetch('/discount/'+encodeURIComponent(code),{redirect:'follow'})
      .then(drawerHtml)
      .then(function(tmp){
        var dc=tmp&&tmp.querySelector('.dcode');
        var ok=dc&&dc.dataset.applied==='true';
        if(ok)return swapPanel(tmp);
        // Shopify will not say WHY it was refused — wrong code, expired, or
        // usage limit reached all look identical from here. So the message
        // states what we know and names the cap rather than guessing.
        if(msg){
          msg.dataset.state='bad';
          msg.textContent=code.toUpperCase()==='FIRST100'
            ? 'FIRST100 is not applying — it is limited to the first 100 orders, so it may already be used up.'
            : 'That code is not applying to this cart.';
        }
        input.select();
      })
      .catch(function(){
        if(msg){msg.dataset.state='bad';msg.textContent='Could not check that code. Try again at checkout.';}
      })
      .finally(function(){btn.disabled=false;f.dataset.busy='false';});
  });

  // add-to-cart posts in the background and opens the drawer instead of
  // navigating to /cart — the whole point of the change
  var form=document.getElementById('pdp-form');
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var fd=new FormData(form);
      d.dataset.busy='true';
      fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
        .then(function(r){
          if(!r.ok)throw new Error('add failed');
          return refresh();
        })
        .then(open)
        .catch(function(){ form.submit(); })   // fall back to a real POST
        .finally(function(){d.dataset.busy='false';});
    });
  }
})();


// CART PAGE DISCOUNT (2026-07-30). The apply/remove handlers above are bound to
// the drawer element, so on /cart they did not exist: the page rendered a
// subtotal reduced by a code with no control to clear it.
//
// This is deliberately NOT a copy of the drawer logic. The drawer re-renders
// itself through the Section Rendering API because it must not navigate; the
// cart page has no such constraint, so both actions end in a reload and Liquid
// re-renders the whole page from the real cart. Less code, and the same rule
// holds — the applied state is never computed in JavaScript.
//
// Remove is POST /cart/update.js with an empty discount. The three plausible
// alternatives all fail and are documented above: /cart/clear.js empties the
// cart but the discount survives the re-add, bare /discount/ is a 404, and the
// discount_code cookie is deletable but deleting it changes nothing because the
// code is held on the cart server-side.
(function(){
  var scope=document.querySelector('[data-discount-scope="page"]');
  if(!scope)return;

  scope.addEventListener('click',function(e){
    if(!e.target.closest('[data-discount-clear]'))return;
    e.preventDefault();
    scope.dataset.busy='true';
    fetch('/cart/update.js',{method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({discount:''})})
      .then(function(){location.reload();})
      .catch(function(){scope.dataset.busy='false';});
  });

  // Click, not submit. The cart page's whole body is inside <form action="/cart">
  // and HTML forbids nested forms, so the discount block here is a div — there is
  // no submit event to listen for. Enter in the field is wired explicitly below,
  // because a div does not give it for free the way a form does.
  function applyCode(f){
    var input=f.querySelector('.dcode__in');
    var code=(input.value||'').trim();
    if(!code){input.focus();return;}
    var btn=f.querySelector('.dcode__go');
    var msg=f.querySelector('[data-discount-msg]');
    btn.disabled=true; f.dataset.busy='true';
    if(msg){msg.textContent='Checking…'; msg.dataset.state='';}
    // /discount/<code> is the only storefront route that applies a code without
    // going to checkout. It answers 200 whether or not the code was accepted, so
    // the reload is the check: if Liquid comes back with the applied state, it
    // worked. Nothing here decides that.
    try{sessionStorage.setItem('plevo_discount_try',code);}catch(e){}
    fetch('/discount/'+encodeURIComponent(code),{redirect:'follow'})
      .then(function(){location.reload();})
      .catch(function(){
        try{sessionStorage.removeItem('plevo_discount_try');}catch(e){}
        if(msg){msg.dataset.state='bad';msg.textContent='Could not check that code. Try again at checkout.';}
        btn.disabled=false; f.dataset.busy='false';
      });
  }

  // A REJECTED CODE HAS TO SAY SO. /discount/<code> answers 200 whether or not
  // the code was accepted, and this surface reloads rather than re-rendering a
  // section, so without this the page would come back with an empty field and no
  // explanation — a silent no-op.
  //
  // This matters on launch night specifically: FIRST100 is capped at 100 orders
  // and 170 people hold it, so customer 101 onward WILL be refused, and they were
  // told in the email that the cap exists. The attempt is carried across the
  // reload in sessionStorage, then compared against what Liquid rendered: if the
  // applied state did not come back, the code did not take.
  try{
    var tried=sessionStorage.getItem('plevo_discount_try');
    if(tried){
      sessionStorage.removeItem('plevo_discount_try');
      if(scope.dataset.applied!=='true'){
        var m=scope.querySelector('[data-discount-msg]');
        if(m){
          m.dataset.state='bad';
          m.textContent = tried.toUpperCase()==='FIRST100'
            ? 'FIRST100 is not applying — it is limited to the first 100 orders, so it may already be used up.'
            : 'That code is not applying to this cart.';
        }
      }
    }
  }catch(e){}

  scope.addEventListener('click',function(e){
    var b=e.target.closest('[data-discount-apply]');
    if(!b)return;
    e.preventDefault();
    var f=b.closest('[data-discount]');
    if(f)applyCode(f);
  });

  scope.addEventListener('keydown',function(e){
    if(e.key!=='Enter')return;
    var input=e.target.closest('.dcode__in');
    if(!input)return;
    // Without this, Enter in a field inside the cart form submits the CART —
    // the customer would get a cart update instead of their discount.
    e.preventDefault();
    var f=input.closest('[data-discount]');
    if(f)applyCode(f);
  });
})();


// INTENT POPUP (2026-07-31). Shows once per visitor per 7 days, after a delay,
// and never where it would do harm.
//
// The suppression rules are the point of this block, not the show logic:
//   · /cart and /checkout — someone who has already decided does not need to be
//     asked what they want. Interrupting there loses a sale you had.
//   · the product page — the tiers are already on screen; the popup would push
//     a 2-Pack at someone looking directly at the 2-Pack.
//   · once per 7 days, in localStorage, keyed by version so the key can be
//     retired without stranding visitors who dismissed an older one.
//
// Dismissal is remembered whether they choose an option or close it. Choosing
// navigates away, so the write has to happen before the click completes.
(function(){
  var el=document.getElementById('intent');
  if(!el)return;

  var KEY='plevo_intent_v1';
  var path=location.pathname;
  if(/^\/(cart|checkout)/.test(path))return;
  if(/^\/products\//.test(path))return;

  var seen=null;
  try{ seen=localStorage.getItem(KEY); }catch(e){ return; }   // private mode: stay silent
  if(seen && (Date.now()-parseInt(seen,10)) < 7*24*60*60*1000) return;

  function remember(){ try{ localStorage.setItem(KEY,String(Date.now())); }catch(e){} }

  var lastFocus=null;
  function open(){
    lastFocus=document.activeElement;
    el.dataset.open='true';
    el.setAttribute('aria-hidden','false');
    var first=el.querySelector('.intent__opts a');
    if(first)first.focus();
    document.addEventListener('keydown',onKey);
  }
  function close(){
    remember();
    el.dataset.open='false';
    el.setAttribute('aria-hidden','true');
    document.removeEventListener('keydown',onKey);
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  function onKey(e){
    if(e.key==='Escape'){close();return;}
    if(e.key!=='Tab')return;
    // focus trap: the panel is the whole dialog, so cycle within it
    var f=el.querySelectorAll('a[href],button:not([disabled])');
    if(!f.length)return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
  }

  el.addEventListener('click',function(e){
    if(e.target.closest('[data-intent-close]')){ e.preventDefault(); close(); return; }
    // an option was chosen: record it before the navigation lands
    if(e.target.closest('.intent__opts a')) remember();
  });

  // `|| 6` would have swallowed a delay of 0 — zero is falsy, so setting the
  // popup to fire immediately would silently have given the 6s default instead.
  // Parse, then test for NaN, so 0 survives.
  var d=parseInt(el.dataset.delay,10);
  if(isNaN(d))d=6;
  if(d<=0){
    // immediate, but still after paint — opening mid-parse fights the browser
    // for the first frame and the panel animates in half-rendered
    requestAnimationFrame(function(){requestAnimationFrame(open);});
  }else{
    setTimeout(open,d*1000);
  }
})();
